module.exports = __webpack_public_path__ + "static/media/scooter.e20470ae.svg";